import UserFeedbackModal from './UserFeedbackModal';
export default UserFeedbackModal;